<template lang="pug">
  #News
    v-card(width="100%" height="400",dark )
      v-img(src="../../assets/img/1592904485.jpg" height="100%" style="margin-top:-85px" )
        v-row(align="center" style="height:100%")
          v-col(cols="12" align="center")
            .display-2.font-weight-black.article-title News & Updates
    v-container()
      v-card.my-3.mx-auto.align-self-center( v-for="(article, i) in newsList" :key="i" max-width="600px" )
        .noImage()
          v-img.white--text.align-end( :src="require(`../../assets/img/${article.image}`)" height="200px" )
            v-card-title 
              .display-1 {{article.title}}
        v-card-subtitle
          | {{article.date}}
        v-card-text
          .body-1 {{article.body.split('. ')[0]}}. 
        v-card-actions
          v-spacer
          v-btn.accent.text--white( @click="toNews(article)" ) Read More...
</template>

<script>
import axios from 'axios';
export default {
  created() {
    axios
      .get('/data/news.json')
      .then(res => {
        console.log('created -> res', res);
        this.newsList = res.data.data;
      })
      .catch(err => console.log(err));
  },
  data() {
    return {
      newsList: [],
      theData: [
        {
          id: '8401',
          date: 'Feb 20, 2020',
          image: require('../../assets/img/951182240.jpeg'),
          title: 'First News',
          body:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
          id: '8402',
          date: 'Feb 20, 2020',
          image: '',
          title: 'Second News',
          body:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
          id: '8403',
          date: 'Feb 20, 2020',
          image: require('../../assets/img/951182240.jpeg'),
          title: 'Third News',
          body:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
          id: '8404',
          date: 'Feb 20, 2020',
          image: require('../../assets/img/951182240.jpeg'),
          title: 'Fourth News',
          body:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        }
      ]
    };
  },
  methods: {
    toNews(article) {
      this.$store.commit('setArticle', article);
      this.$router.push('/welcome/news-article/' + article.id);
    },
    getNews() {}
  }
};
</script>

<style lang="stylus" scoped>
.article-title
  background-color rgb(171, 92, 177)
  color #fff
  font-family Cardo, 'san-serif' !important
  line-height 65px

.noImage
  background-color var(--v-accent-base)
  height 200px
  width 100%
</style>
